import type { ReactNode } from 'react';
import { useLogger, useServices } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import type { QuizScreenProps, BuildRequestStepData } from '@packages/shared/core/quiz/entities';

type BuildRequestQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const BuildRequestQuizStep = ({ id, renderQuizScreen }: BuildRequestQuizStepProps) => {
  const logger = useLogger();
  const { analyticsService } = useServices();

  const { back, next, stepData, updateUserPreferences, userPreferences, totalSteps, stepOrder } = useQuizStep(id);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey, analytic } = stepData as BuildRequestStepData;
  const userRequest = (userPreferences.buildRequest as string | undefined) ?? '';

  const goBack = async () => back();

  const onIcebreakerSelect = (icebreaker: string) => {
    analyticsService.trackQuizEvent(analytic.icebreakerClickEvent, {
      context: icebreaker,
    });
  };

  const onContinue = (request: string) => {
    updateUserPreferences(dataKey, request);
    next(request);
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        onIcebreakerSelect,
        totalSteps,
        stepOrder,
        userRequest,
        ...(stepData as BuildRequestStepData),
      })}
    </>
  );
};

export default BuildRequestQuizStep;
